

































































































































































import { Component, Emit, Mixins, Prop, Vue, Watch } from "vue-property-decorator";
import moment from 'moment';
import SecurityMixin from "water-rest/src/mixins/SecurityMixin.vue";
import { ModulePresetModel } from 'water-rest/src/model/messaging/ModulePresetModel';
import NotificationReadConfirmModal from '@/components/modal/NotificationReadConfirmModal.vue';
import NotificationReadCriticalModal from '@/components/modal/NotificationReadCriticalModal.vue';
import {
  NotificationDto,
  NotificationDtoExtended,
} from 'water-rest/src/model/messaging/NotificationDto';
import { readNotification } from 'water-rest/src/service/MessagingService';
import { errorToast, warningToast } from "water-layout/src/services/toastr-service";

@Component({})
export default class NotifyPanel extends Mixins(Vue, SecurityMixin) {
  @Prop({ type: Boolean, default: false }) value!: boolean;
  @Prop() notifyMessages!: NotificationDto[];
  @Prop() moduleList!: ModulePresetModel[];
  @Prop({ default: 5 * 60 * 1000 }) notificationModalInterval!: number; // 5 минут по умолчанию

  sectedModule: ModulePresetModel | null = null;
  notificationQueue: NotificationDtoExtended[] = [];
  notificationQueueTimeout: number | null = null;
  notificationQueueShownCount = 0;

  clickOutsidePanel = true;
  clickOutsideSelector = false;
  selectorModulesOpened = false;
  canShowCriticalModal = true;

  unreadOnly = false;
  hasUnreadByModule = false;
  isFirstVisit = true;
  isReadingMessageInProcess = false;

  get notifyMessagesByModule(): NotificationDto[] {
    if (this.sectedModule) {
      const messages = this.notifyMessages.filter(item => {
        if (this.unreadOnly) {
          return this.sectedModule?.senderCodes?.includes(item.systemName) && !item.isRead;
        } else {
          return this.sectedModule?.senderCodes?.includes(item.systemName);
        }
      }) || [];
      this.hasUnreadByModule = !!messages.find(item => !item.isRead);
      return messages;
    } else {
      const messages = this.notifyMessages.filter(item => {
        if (this.unreadOnly) {
          return !item.isRead;
        } else {
          return true;
        }
      });
      this.hasUnreadByModule = !!messages.find(item => !item.isRead);
      return messages;
    }
  }

  get hasReadedMessages(): boolean {
    const hasReadedMessages = !!this.notifyMessages.find(item => item.isRead);
    if (!hasReadedMessages) {
      this.unreadOnly = false;
    }
    return hasReadedMessages;
  }

  get selectedModuleName(): string {
    return this.sectedModule === null ? 'Все модули' :
      (this.sectedModule?.senderName || 'Не указано');
  }

  get hasMessages(): boolean {
    if (this.unreadOnly) {
      const unreaded = this.notifyMessages.find(i => !i.isRead);
      return !!unreaded;
    }
    return !!this.notifyMessages?.length;
  }

  @Watch('notifyMessages', { deep: false })
  async onNotificationMessages(notifyMessages: NotificationDto[]) {
    let hasNewCriticalMessages = false;
    // Добавление в очередь для оповещения модальными окнами только новые
    for (const message of notifyMessages) {
      if (!message.isRead && [ 'CRITICAL' ].includes(message.critical)) {
        const found = this.notificationQueue.find(item => {
          return item.notificationId === message.notificationId;
        });
        if (!found) {
          hasNewCriticalMessages = true;
          this.notificationQueue.unshift({ ...message, needToShow: true });
        }
      }
    }
    if (hasNewCriticalMessages) {
      if (!this.isFirstVisit) {
        await this.showLastCritical();
      }
      this.isFirstVisit = false;
      this.notificationQueueRestart();
    }
  }

  mounted() {
    window.addEventListener('mousedown', event => this.onMouseDown(event));
    window.addEventListener('resize', this.close);
  }

  beforeDestroy() {
    window.removeEventListener('mousedown', event => this.onMouseDown(event));
    window.removeEventListener('resize', this.close);
  }

  onMouseDown(event: any) {
    const clickToIcon = event?.target?.parentElement?.id === 'NotificationHandler';
    if (clickToIcon) {
      return;
    }
    if (this.clickOutsidePanel) {
      this.close();
    }
    if (this.clickOutsideSelector) {
      this.selectorModulesOpened = false;
    }
    this.clickOutsidePanel = true;
    this.clickOutsideSelector = true;
  }

  onSelectorModule() {
    this.selectorModulesOpened = !this.selectorModulesOpened;
    this.clickOutsideSelector = false;
  }

  onSetModules(value: ModulePresetModel | null) {
    this.sectedModule = value;
    this.selectorModulesOpened = false;
  }

  onViewNotification(message: NotificationDto) {
    if ([ 'CRITICAL' ].includes(message?.critical)) {
      this.showCriticalModal(message);
    }
  }

  async onReadConfirm(messages: NotificationDto[], all = false) {
    if (!messages?.length) {
      return;
    }
    if (this.isReadingMessageInProcess) {
      warningToast('Дождитесь завершения процедуры прочтения сообщений');
      return;
    }
    if (this.hasCriticalUnread(messages)) {
      this.canShowCriticalModal = false;
      await this.$rir.modal.open(NotificationReadConfirmModal, {
        messages: messages.filter(message => !message.isRead),
        moduleList: this.moduleList,
        all,
        onConfirm: async () => {
          if (messages !== null) {
            this.isReadingMessageInProcess = true;
            await this.onReadMessages(messages);
            this.isReadingMessageInProcess = false;
          }
          this.$rir.modal.close(null, true);
        },
        onClose: () => {
          this.$rir.modal.close(null, true);
        },
      });
      this.canShowCriticalModal = true;
    } else {
      if (messages !== null) {
        this.isReadingMessageInProcess = true;
        await this.onReadMessages(messages);
        this.isReadingMessageInProcess = false;
      }
    }
  }

  hasCriticalUnread(messages: NotificationDto[]): boolean {
    const critical = messages?.find(message => {
      return this.isCritical(message) && !message.isRead;
    });
    return !!critical;
  }

  isCritical(message: NotificationDto | null = null): boolean {
    if (!message) {
      return false;
    }
    return [ 'CRITICAL' ].includes(message?.critical);
  }

  isShowIcon(message: NotificationDto): boolean {
    return [ 'HIGH', 'CRITICAL' ].includes(message?.critical);
  }

  formatDate(date: string | null = null, ignoreTimezone: boolean | null = null): string {
    if (!date) {
      return '—';
    }
    const dateInit = ignoreTimezone ? moment(date.replace(/[+-]\d{2}:\d{2}$/, '')) : moment(date);
    return dateInit.format('DD.MM.YYYY HH:mm');
  }

  formatModuleName(message: NotificationDto | null = null): string | null {
    if (!message?.systemName || !this.moduleList) {
      return null;
    }
    const find = this.moduleList.find(item => item?.senderCodes?.includes(message?.systemName));
    return find?.senderName || null;
  }

  formatMessageText(message: NotificationDto | null = null): string | null {
    return message?.message || 'Текс оповещения отсутствует';
  }

  notificationQueueRestart() {
    if (this.notificationQueueTimeout) {
      clearTimeout(this.notificationQueueTimeout);
      this.notificationQueueTimeout = null;
    }
    this.notificationQueueTimeout = setTimeout(async () => {
      await this.showLastCritical();
      if (this.notificationQueueShownCount < 3 && this.hasCriticalUnread(this.notificationQueue)) {
        this.notificationQueueRestart();
      }
      if (this.notificationQueueShownCount === 3) {
        setTimeout(() => { this.showSummaryModal(); }, this.notificationModalInterval)
      }
    }, this.notificationModalInterval);
  }

  async showLastCritical() {
    if (!this.canShowCriticalModal) {
      return;
    }
    for (const index in this.notificationQueue) {
      const message = this.notificationQueue[index];
      if (message.needToShow && !message.isRead) {
        await this.showCriticalModal(message);
        break;
      }
    }
  }

  async showCriticalModal(message: NotificationDto | null) {
    if (!message || !this.canShowCriticalModal) {
      return;
    }
    this.canShowCriticalModal = false;
    await this.$rir.modal.open(NotificationReadCriticalModal, {
      message,
      isSummary: false,
      count: null,
    });
    if (message) {
      await this.onReadMessages([ message ]);
    }
    this.notificationQueueShownCount++;
    this.canShowCriticalModal = true;
  }

  async showSummaryModal(): Promise<void> {
    const count = this.notificationQueue.filter(item => !item.isRead).length;
    if (!count || count === 0) {
      this.notificationQueueShownCount++;
      return;
    }
    this.canShowCriticalModal = false;
    await this.$rir.modal.open(NotificationReadCriticalModal, {
      message: null,
      isSummary: true,
      count,
    });
    this.notificationQueueShownCount++;
    this.canShowCriticalModal = true;
  }

  async onReadMessages(messages: NotificationDto[]) {
    for await (const message of messages) {
      const notificationId = message?.notificationId || null;
      if (!localStorage.getItem('authData')) {
        break;
      }
      try {
        if (!notificationId) {
          throw 'Отсутствует идентификатор оповещения';
        }
        if (!message.isRead) {
          await readNotification(message);
        }
      } catch (error) {
        console.error(error);
        // TODO: Уточнить необходимость вывода ошибок с бэка,
        // если она "Invalid UUID string: 1" нечеловекопонятная
        // if (error instanceof Promise && (await error as any)?.messages?.length) {
        //   for (const message of (await error as any)?.messages) {
        //     errorToast(message);
        //   }
        // }
        errorToast(`Ошибка установки оповещению статуса прочитанного`);
      } finally {
        if (notificationId) {
          for (const index in this.notificationQueue) {
            const message = this.notificationQueue[index];
            if (message.notificationId === notificationId) {
              message.needToShow = false;
              message.isRead = true;
            }
          }
          this.onReadMessage(notificationId);
        }
      }
    }
  }

  @Emit('close') close() { return; }

  @Emit('onReadMessage') onReadMessage(id: string): string {
    return id;
  }
}
